import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import LiterarySidebar from '../Literaryclub2023/components/LiterarySidebar';
import Sidebar2025 from '../Literaryclub2023/components/Sidebar2025';

const EnglishCCAClass3to5 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA/4.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA/5.webp`;
    const p6 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA/6.webp`;

  
    const photos = [
        {
            src: p1,
            source: p1,
            rows: 2,
            cols: 2,
        },
        {
            src: p2,
            source: p2,
            rows: 1.4,
            cols: 2,
        },
        {
            src: p3,
            source: p3,
            rows: 1.4,
            cols: 2,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1.4,
            cols: 2,
        },
        {
            src: p5,
            source: p5,
            rows: 1.4,
            cols: 2,
        },
        {
            src: p6,
            source: p6,
            rows: 1.4,
            cols: 2,
        }
    ];

    return (
        <Main>

            <Container>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                                <Typography variant='h5' align='center' >
                                ENGLISH CCA
                                </Typography>
                                <br></br>
                                                               <Typography variant='h7' align='justify' >
                                                                Class 3: Picture Talk - Observe, Think and Chat
                                                                <br></br>
                                                                Class 4: Grammar Explorers: Parts of Speech in Action
                                                                <br></br>
                                                                Class 5: Comic to Stage – Creativity in Motion 
                                                                </Typography>
                                                                <br></br>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 3-5  &  Date: 9 & 10 October 2025
                                </Typography>
                                

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The English CCA competitions for Classes 3, 4 and 5 held on 9 and 10 October 2025, provided a wonderful platform for students to showcase their creativity, language skills and self-expression. The Picture Talk Competition for Class 3 encouraged keen observation, imagination and fluent expression as students confidently described picture scenes using clear and meaningful sentences. 
                                <br></br>
                                Grammar Explorers: Parts of Speech in Action for Class 4 blended learning grammar concepts with creativity and teamwork, as students designed informative charts, shared examples and participated enthusiastically in interactive quizzes. 
                                <br></br>
                                The Comic to Stage Competition for Class 5 integrated art, drama and communication, as students designed comic strips and transformed them into dynamic stage performances that conveyed strong social and promotional messages. These competitions not only enriched students’ vocabulary, grammar and presentation skills but also nurtured spontaneity, critical thinking, collaboration and confidence—helping them grow into expressive and articulate speakers.
                                <br></br>

                                </Typography>
                            </Box>
                           <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                "When art meets words, imagination takes the stage. Together we learn, express and create — one story, one sentence, one stage at a time."

                                <br />
                            </Typography>
                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>

                        
                        <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box>
                        {/* <Box marginBottom={4}>
                                    <Archive2023/>
                        </Box> */}
                        <Box marginBottom={4}>
                                    <LiterarySidebar/>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default EnglishCCAClass3to5;